export default {
    route: {
        title: "商城",
        desc: "品质甄选 优质服务",
    },
    common: {
        category: "类别",
        subcategory: "子类",
        all: "全部",
        featured: "推荐",
        search: "请输入关键词",
        search_goods: "搜索商品",
        keyword: "关键词",
        reset_filter: "重置筛选",
        loading: "加载中···",
        no_more: "没有更多了～",
        add_cart_success: "成功加入购物车",
        add_cart_fail: "加车失败",
    },
    more: {
        favorites: "收藏夹",
    },
    single: {
        all: "全部",
        price: "价格",
        price_start: "起",
        stock: "库存",
        stock_unit: "{num} 件",
        deliver: "配送至",
        param: "参数",
        spec: "规格",
        color: "颜色",
        size: "尺寸",
        product: "产品",
        detail: "详情",
        evaluate: "评价",
        join_cart: "加入购物车",
        buy: "立即购买",
        sold_out: "已下架",
        unavailable_tip: "商品已下架，暂不可操作",
        style: "款式选择",
        select: "{num} 款可选",
        fav: "收藏",
        service: "客服",
        cart: "购物车",
        address: "选择配送地址",
        addr_add: "添加新地址",
        select_tip: "请选择规格",
        restock_notice: "提醒补货",
        restock_success: "补货提醒已提交",
        restock_fail: "补货提醒提交失败",
        missing_title: "商品不存在",
        missing_desc: "该商品可能已删除、下架，或链接地址不正确。",
        back_to_list: "返回商品列表",
    },
    cart: {
        title: "我的购物车",
        settlement: "结算",
        all: "全选",
        del: "删除",
        del_tip: "是否移除该商品？",
        total: "合计",
        edit: "修改",
        success_tip: "成功加入购物车，是否立即去购物车结算？",
        confirm: "去结算",
        cancel: "继续购物",
        select_tip: "请先选择产品",
        empty: "暂无商品",
        item_count: "共 {count} 件商品",
        selected_count: "已选择 {count} 件可结算商品",
        goods: "商品",
        variant: "规格",
        unit_price: "单价",
        quantity: "数量",
        subtotal: "小计",
        stock_low: "库存紧张",
        default_variant: "默认规格",
        unavailable: "商品暂不可结算",
        goods_missing: "商品不存在",
        goods_unavailable: "商品已下架",
        variant_missing: "规格不存在",
        variant_unavailable: "规格不可售",
        insufficient_stock: "库存不足",
        remove_invalid: "移除失效商品",
        remove_invalid_tip: "是否移除所有失效商品？",
    },
    fav: {
        title: "我的收藏夹",
        empty: "暂无收藏商品",
        saved_count: "已收藏 {count} 件商品",
        saved_hint: "常买好物可以先放在这里，挑选规格时再进入详情确认。",
        page_range: "{start}-{end} / 共 {total}",
        no_desc: "暂无商品简介",
        view_detail: "查看详情",
        close: "关闭",
        remove_invalid: "移除全部失效商品",
        remove_invalid_tip: "是否移除收藏夹中全部已下架商品？",
        remove_invalid_success: "已移除 {count} 件失效商品",
        invalid_count: "{count} 件失效商品",
        no_invalid_goods: "暂无失效商品",
        del_tip: "是否移除该商品？",
        del_success: "取消收藏",
        del_fail: "取消收藏失败",
        no_more: "没有更多了～",
        add: "加入收藏",
        remove: "移出收藏",
        add_success: "收藏成功",
        add_fail: "添加失败",
        del: "删除",
    },
};
